"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventsHelper_1 = require("../utils/eventsHelper");
var Tabs = /** @class */ (function () {
    function Tabs(documentObject) {
        this.initTabs(documentObject);
        this.initDropdownClick(documentObject);
        this.initShowHideDropdown(documentObject);
    }
    Tabs.prototype.initTabs = function (documentObject) {
        eventsHelper_1.default.live('.js-tabs .c-tabs-item:not(.c-tabs-expander), .js-tabs .c-tabs-dropdown-menu-item, .js-tabs .c-tabs__item:not(.c-tabs__expander), .js-tabs .c-tabs__dropdown-menu-item', 'click', function (event, tabItem) {
            event.preventDefault();
            showTab(tabItem);
        }, documentObject);
        function showTab(clickedTabItem) {
            var tabs = clickedTabItem.closest('.js-tabs');
            var allTabItems = tabs.querySelectorAll('.c-tabs-item, .c-tabs__item');
            var allDropdownItems = tabs.querySelectorAll('.c-tabs-dropdown-menu-item, .c-tabs__dropdown-menu-item');
            var allTabPanes = tabs.querySelectorAll('.c-tabs-pane, .c-tabs__pane');
            var targetTabPane = tabs.querySelector(clickedTabItem.getAttribute('href'));
            allTabItems.forEach(function (element) {
                element.classList.remove('is-active');
                element.setAttribute('aria-selected', false);
            });
            allDropdownItems.forEach(function (element) {
                element.classList.remove('is-active');
                element.setAttribute('aria-selected', false);
            });
            allTabPanes.forEach(function (element) {
                element.classList.remove('is-active');
            });
            clickedTabItem.classList.add('is-active');
            clickedTabItem.setAttribute('aria-selected', true);
            targetTabPane.classList.add('is-active');
        }
    };
    Tabs.prototype.initDropdownClick = function (documentObject) {
        eventsHelper_1.default.live('.js-tabs .c-tabs-expander, .js-tabs .c-tabs__expander', 'click', function (event, tabItem) {
            event.preventDefault();
            expand(tabItem);
        }, documentObject);
        function expand(clickedTabItem) {
            var dropdown = clickedTabItem.nextElementSibling;
            dropdown.classList.toggle('is-open');
            clickedTabItem.classList.toggle('is-open');
            if (dropdown.getAttribute("aria-hidden")) {
                dropdown.setAttribute('aria-hidden', false);
                clickedTabItem.setAttribute('aria-expanded', true);
            }
            else {
                dropdown.setAttribute('aria-hidden', true);
                clickedTabItem.setAttribute('aria-expanded', false);
            }
        }
        eventsHelper_1.default.live('body', 'click', function (event) {
            var clickedElement = event.target;
            if (clickedElement.classList) {
                var dropdown = clickedElement.classList.contains('c-tabs-expander') || clickedElement.classList.contains('c-tabs__expander');
                if (!dropdown && event.keyCode !== 13) {
                    var activeDropdown = documentObject.querySelectorAll('.c-tabs-expander.is-open, .c-tabs__expander.is-open');
                    if (activeDropdown.length) {
                        for (var i = 0; i < activeDropdown.length; i++) {
                            var activeElement = activeDropdown[i];
                            if (activeElement.classList.contains('is-open')) {
                                var dropdown_1 = activeElement.nextElementSibling;
                                dropdown_1.classList.remove('is-open');
                                dropdown_1.setAttribute('aria-hidden', true);
                                activeElement.classList.remove('is-open');
                                activeElement.setAttribute('aria-expanded', false);
                            }
                        }
                    }
                }
            }
        });
    };
    Tabs.prototype.initShowHideDropdown = function (documentObject) {
        var tabs = documentObject.querySelectorAll('.js-tabs.js-tabs-dropdown, .js-tabs.js-tabs__dropdown');
        setTimeout(function () {
            checkDropdownVisibility();
        }, 100);
        // Try once more if dom was not ready 
        setTimeout(function () {
            checkDropdownVisibility();
        }, 500);
        window.addEventListener('resize', function (e) {
            checkDropdownVisibility();
        });
        function checkDropdownVisibility() {
            if (tabs.length > 0) {
                tabs.forEach(function (element) {
                    var tabsWidth = element.clientWidth;
                    var tabElementsWidth = 0;
                    var tabElements = element.querySelectorAll('.c-tabs-item:not(.c-tabs-expander), .c-tabs__item:not(.c-tabs__expander)');
                    var dropdownElement = element.querySelector('.c-tabs-dropdown, .c-tabs__dropdown');
                    var dropdownElementItems = dropdownElement.querySelectorAll('.c-tabs-dropdown-menu-item, .c-tabs__dropdown-menu-item');
                    var dropdownElementWidth = dropdownElement.clientWidth;
                    var targetWidth = tabsWidth - dropdownElementWidth;
                    if (tabElements.length > 0) {
                        tabElements.forEach(function (element, index) {
                            tabElementsWidth = tabElementsWidth + element.clientWidth + 5;
                            if (tabElementsWidth > targetWidth) {
                                element.classList.add('is-hidden-opacity');
                                element.setAttribute('aria-hidden', true);
                                element.setAttribute('tabindex', -1);
                                dropdownElement.classList.remove('is-hidden-opacity');
                                dropdownElementItems[index].classList.remove('is-hidden');
                            }
                            else {
                                element.classList.remove('is-hidden-opacity');
                                element.setAttribute('aria-hidden', false);
                                element.setAttribute('tabindex', 0);
                                dropdownElement.classList.add('is-hidden-opacity');
                                dropdownElementItems[index].classList.add('is-hidden');
                            }
                        });
                    }
                });
            }
        }
    };
    return Tabs;
}());
exports.default = Tabs;
